import { FunctionComponent } from "react";
import { OptionsSelectField } from "@bps/fluent-ui";
import { useSecurityBusinessRoles } from "@libs/api/gateways/plt/plt-gateway.hooks";
import { BusinessSecurityRoleDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

interface BusinessSecurityRolesSelectFieldProps {
  name: string;
  multiSelect: boolean;
  tenantId?: string;
}

export const BusinessSecurityRolesSelectField: FunctionComponent<BusinessSecurityRolesSelectFieldProps> = ({
  name,
  tenantId,
  multiSelect
}) => {
  const { isLoading, error, data = [] } = useSecurityBusinessRoles({
    tenantId
  });

  const options = data
    .filter(d => !!d.isActive)
    .map((d: BusinessSecurityRoleDto) => ({
      key: d.code,
      text: d.text
    }));

  return (
    <OptionsSelectField
      required
      label="Business roles"
      options={options}
      name={name}
      noOptionsText="Set up components first!"
      multiSelect={multiSelect}
      loading={isLoading}
      errorMessage={error?.message}
      styles={{ root: { width: 300 } }}
    />
  );
};
